import React from 'react';

const Error = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1 className="text-4xl text-red-600 font-bold">404 - Page Not Found</h1>
    </div>
  );
};

export default Error;
